// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"JK-z","carouselContainer":"KK-z"};